module.exports = __webpack_public_path__ + "static/media/eye-blue.2a8f8639.svg";